export default __webpack_public_path__ + "static/media/Medical-02-512.7dbc7713.png";